import { render, staticRenderFns } from "./noteinfo.vue?vue&type=template&id=ff5be3f0&scoped=true"
import script from "./noteinfo.vue?vue&type=script&lang=js"
export * from "./noteinfo.vue?vue&type=script&lang=js"
import style0 from "./noteinfo.vue?vue&type=style&index=0&id=ff5be3f0&prod&scoped=true&lang=less"
import style1 from "./noteinfo.vue?vue&type=style&index=1&id=ff5be3f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5be3f0",
  null
  
)

export default component.exports